import { InfiniteData, useInfiniteQuery, useQuery } from "react-query";

import { makeSimpleGetRequest } from "lib/axios";
import { DynamicRestQueryOptions, makeQueryString } from "lib/dynamicRest";
import { INVENTORY_URL } from "services/constants";

import { InventoryListing, InventoryListingsPaginatedResponse } from "./types";

const getInventoryListings = async (queryOptions: DynamicRestQueryOptions) => {
  const queryString = makeQueryString(queryOptions);
  return makeSimpleGetRequest<InventoryListing[]>(
    `${INVENTORY_URL}/listings/?${queryString}`,
  );
};

const getInventoryListingsPaginated = async (
  queryOptions: DynamicRestQueryOptions,
) => {
  const queryString = makeQueryString(queryOptions);
  return makeSimpleGetRequest<InventoryListingsPaginatedResponse>(
    `${INVENTORY_URL}/listings/?${queryString}`,
  );
};

const QUERY_CONFIG = {
  staleTime: 10 * 60 * 1000, // 10min = 10 min * 60 sec/min * 1000 ms/sec
};

export const useInventoryListings = (
  queryOptions: DynamicRestQueryOptions | null,
  onSuccess?: (data: InventoryListing[]) => void,
) =>
  useQuery(
    ["inventory-listings", queryOptions],
    () => exported.getInventoryListings(queryOptions),
    {
      enabled: queryOptions !== null,
      ...QUERY_CONFIG,
      onSuccess,
    },
  );

export const useInventoryListingsPaginated = (
  queryOptions: DynamicRestQueryOptions | null,
  onSuccess?: (data: InfiniteData<InventoryListingsPaginatedResponse>) => void,
) =>
  useInfiniteQuery(
    ["inventory-listings-paginated", queryOptions],
    () => exported.getInventoryListingsPaginated(queryOptions),
    {
      enabled: queryOptions !== null,
      ...QUERY_CONFIG,
      onSuccess,
    },
  );

const exported = {
  getInventoryListings,
  getInventoryListingsPaginated,
};
export default exported;
